import Toastify from "toastify";

export const GiftProduct = ({ currentCycle = 0 }) => ({
  currentPrice: 0,
  priceData: 0,
  displayedPrice: '',
  priceValueContainer: ".gift-product-price-value",
  giftProdyuctButtons: ".gift-product__buttons",
  subscriptionTriggerButton: ".gvlo-subscription-trigger",
  gvloButton: ".gvlo-button",
  cycle: 'select[name="cycle"]',
  flavor: 'select[name="Flavor"]',
  booster: 'select[name="Booster"]',
  numberOfDeliveries: 0,
  giftPrice: 0,
  subscription: 0,
  selectedOptions: {},
  currentCycle,

  get basePrice() {
    const priceData = document.querySelector(this.priceValueContainer)?.innerHTML;

    return parseInt(priceData, 10);
  },
  get productPrice() {
    const subscription = this.numberOfDeliveries || this.subscription;

    return subscription && this.basePrice ? `$${(this.subscription * (this.basePrice / 100))?.toFixed(2)}` : 0;
  },

  init() {
    this.observerCallback = this.observerCallback.bind(this);
    this.setValues = this.setValues.bind(this);

    const observer = new MutationObserver(this.observerCallback);
    const target = document.querySelector(this.giftProdyuctButtons);
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    }

    this.subscription = currentCycle;
    this.displayedPrice = `$${((this.basePrice.toFixed(2) * this.subscription) / 100)?.toFixed(2)} ($${(this.basePrice / 100).toFixed(2)} per delivery)`;

    this.getNumberOfDeliveries();
  },
  observerCallback(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const button = document.querySelector(this.subscriptionTriggerButton);

        if (button) {
          button.addEventListener("click", this.setValues);
          observer.disconnect();
          break;
        }
      }
    }
  },
  setValues(event) {
    const cycleSelect = document.querySelector(this.cycle);
    const boosterSelect = document.querySelector(this.booster);

    this.setDefaultValue(this.cycle, this.subscription);
    this.setDefaultValue(this.flavor, this.selectedOptions?.['Flavor']);
    this.setDefaultValue(this.booster, this.selectedOptions?.['Booster']);

    boosterSelect?.addEventListener("change", () => {
      this.currentPrice = boosterSelect.value === 'Blend' ? 4900 : 6900;

      this.updatePrice(cycleSelect?.value);
    });

    cycleSelect?.addEventListener("change", () => {
      const updatedCycleValue = cycleSelect?.value;

      this.updatePrice(updatedCycleValue);
    });
  },
  updatePrice(numberOfPayment = 1) {
    const atcBtn = document.querySelector(this.gvloButton);
    this.priceData = document.querySelector(this.priceValueContainer)?.innerHTML;
    const basePrice = this.currentPrice ? this.currentPrice : parseInt(this.priceData, 10);
    const updatedPrice = basePrice ? (basePrice / 100) * numberOfPayment : null;

    if (updatedPrice !== null && atcBtn) {
      const existingPriceSpan = atcBtn.previousElementSibling;

      if (existingPriceSpan && existingPriceSpan.classList.contains("calculated-price")) {
        existingPriceSpan.remove();
      }

      const priceElement = document.createElement("span");
      priceElement.classList.add("calculated-price");
      priceElement.textContent = `$${updatedPrice.toFixed(2)} ($${(basePrice / 100).toFixed(2)} per delivery)`;

      atcBtn.parentNode.insertBefore(priceElement, atcBtn);
    }
  },
  getNumberOfDeliveries() {
    const urlParams = new URLSearchParams(window.location.search);
    const cycleParam = urlParams.get("cycles");
    if (cycleParam) {
      this.numberOfDeliveries = parseInt(cycleParam, 10);
      this.priceData = document.querySelector(this.priceValueContainer)?.innerHTML;

      this.subscription = this.numberOfDeliveries;
      this.giftPrice = (this.basePrice / 100) * this.numberOfDeliveries;
    }
  },
  setDefaultValue(selector, value) {
    const selectElement = document.querySelector(selector);

    if (!selectElement) {
      return;
    }

    for (let option of selectElement.options) {
      if (option.value == value) {
        option.selected = true;
        const changeEvent = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(changeEvent);
        break;
      }
    }

    const cycleSelect = document.querySelector(this.cycle);

    if (cycleSelect?.value) {
      this.updatePrice(cycleSelect.value);
    }
  },
  changePrice() {
    setTimeout(() => {
      this.displayedPrice = `$${((this.basePrice.toFixed(2) * this.subscription) / 100)?.toFixed(2)} ($${(this.basePrice / 100).toFixed(2)} per delivery)`;
    }, 800)
  }
});
